import React from 'react'
import { useParams } from 'react-router'

export const useSurveyQueryKey = () => {
  const { surveyId = '' } = useParams<{ surveyId: string | undefined }>()

  return React.useMemo(() => ['UseSurveyQuery_Main', { surveyId }], [surveyId])
}
